import { BillOrderModuleId, BillPaymentModuleId, LocationModuleId, PurchaseOrderModuleId, VendorCreditModuleId, VendorModuleId, VendorReturnModuleId } from './../../../../modules/shared/constants/modules.constant';
import { AppMainService } from './../../../../app-main.service';
import { NotificaitonEmailTemplateConfigModel } from './../../models/notification-email-template.model';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { AccountModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, ProductModuleId, SOModuleId, OpportunityModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { SharedChannelService } from 'src/app/modules/shared/services/channel.service';
import { EmailTemplateService } from '../../services/email-template.service';
import { Subject, takeUntil } from 'rxjs';
import { ConfigurationService } from 'src/app/configurations/configurationService';

@Component({
    selector: 'app-template-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss']
})
export class TemplateTableComponent implements  OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() type;
    @Input() moduleId: number = null;
    templateList: NotificaitonEmailTemplateConfigModel[];
    channelNames: any;

    isView: boolean = false;
    selectedEmailTemplate = null;
    displayEmailTemplate: boolean = false;

    printTemp = null;
    displayPrintTemplate: boolean = false;

    //table data
    firstTimeloading: boolean = true;
    findOrLoadingText: string = "Loading template list...";
    tableShowMore: number[] = [15, 30, 50, 100];
    totalRecords: number = 0;
    first: number = 0;
    pageSize: number = 15;
    pageNumber: number = 1;
    gridState: any = {};

    moduleIds: number[] = [ProductModuleId,EstimateOrderModuleId,SOModuleId,InvoiceOrderModuleId];
    vendorsModuleIds: number[] = [PurchaseOrderModuleId,BillOrderModuleId,BillPaymentModuleId,VendorCreditModuleId,VendorReturnModuleId];
    templateNames = {
        [ProductModuleId]: "Product Template",
        [EstimateOrderModuleId]: "Estimate Template",
        [SOModuleId]: "SalesOrder Template",
        [InvoiceOrderModuleId]: "Invoice Template"
    };

    constructor(
        private confirmationService: ConfirmationService,
        private sharedChannelService: SharedChannelService,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private emailTemplateService: EmailTemplateService,
        private configService: ConfigurationService,
    ) { }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.moduleId?.currentValue) {
            this.moduleId = changes.moduleId.currentValue;
            this.getAllTemplateList(1, 15);
            this.getChannelNames();
        }
    }

    onFilterChange(event: LazyLoadEvent): void {
        const filters = [];
        for (const filterName in event.filters) {
            filters.push({
                field: filterName,
                value: event.filters[filterName].value
            });
        }
        this.gridState['filters'] = filters
    }

    loadTemplateListByFilter(event: LazyLoadEvent): void {
        if(this.firstTimeloading)return;

        if (!event.sortField && !event.filters) {
            if (event.first == 0 && event.rows == 15) {
                this.getAllTemplateList(1, 15);
                return;
            }
        }

        const pageSize: number = event.rows;
        const pageNumber: number = (event.first / event.rows) + 1;
        //if sort exist
        if (event.sortField) {
            const temp = {
                field: event.sortField,
                order: event.sortOrder
            }
            this.gridState['sort'] = temp;
        }
        //if column filter exist
        if (event.filters) {
            this.onFilterChange(event);
        }

        this.getAllTemplateList(pageNumber, pageSize);
    }

    getAllTemplateList(pageNumber: number, pageSize: number){

        if(!this.moduleId)return;

        this.pageNumber = pageNumber;
        const options: any = {};

        // apply field Filter
        if (this.gridState && this.gridState.filters && this.gridState.filters.length) {
            const filterColumns = [];
            this.gridState.filters.map(columnObj => {
                filterColumns.push(columnObj.field);
            });
            let searchValue = this.gridState.filters && this.gridState.filters[0] && this.gridState.filters[0].value ? this.gridState.filters[0].value : '';
            options.filter = {
                field: filterColumns.join(','),
                value: searchValue
            }
        }

        // apply sorting
        if (this.gridState && this.gridState.sort) {
            options.sort = {
                SortBy: this.gridState.sort.field,
                IsAscending: this.gridState.sort.order === 1 ? true : false
            }
        }

        // options.moduleSearchValue = this.moduleSearchValue.length ? this.moduleSearchValue.trim() : '';
        this.appMainService.isShowSpinner('loadingTemplateList');
        this.emailTemplateService.getAllTemplates(this.moduleId, null,pageNumber, pageSize,null, options).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) =>{
                this.appMainService.isHideSpinner('loadingTemplateList');

                let data = response.body == null ? [] : response.body;
                let headers = JSON.parse(response.headers.get('X-Pagination'));
                headers = headers == null ? [] : headers;
                this.totalRecords = headers['TotalCount'] || 0;
                this.firstTimeloading = false;
                this.templateList = data;
                this.findOrLoadingText = this.totalRecords==0 ? 'No template created yet!' : "";
            },
            error: (error) => {
                this.findOrLoadingText = 'No template found!';
                this.appMainService.isHideSpinner('loadingTemplateList');
            }
        })
    }

    loadTemplateList(){
        this.first = 0;
        this.getAllTemplateList(1, 15);
    }

    //*Delete template
    deleteTemplate(template: any) {
        this.confirmationService.confirm({
            message: 'Are you sure want to delete this template?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteTemplateLoader')
                this.emailTemplateService.deleteEmailTemplate(template.id)
                    .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
                        this.appMainService.isHideSpinner('deleteTemplateLoader')
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Template deleted successfully!' });
                        this.loadTemplateList();
                    },
                        err => {
                            this.appMainService.isHideSpinner('deleteTemplateLoader')
                        });
            },
            reject: () => {
            }
        });
    }

    getChannelNames() {
        if (this.moduleIds.includes(this.moduleId)) {
            this.configService.getConfigurationsByTemplateName(this.templateNames[this.moduleId]).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
                const activeChannels = resp.templates?.filter(x => x.isActive == true);
                this.channelNames = activeChannels?.map((c, index) => ({
                    id: c.id,
                    name: c.channelName,
                    isDefault: index == 0,
                }));
            });
        } else if (this.vendorsModuleIds.includes(this.moduleId)) {
            this.sharedChannelService.getChannels(VendorModuleId, true).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
                this.channelNames = res;
            });
        } else {
            const allList = [OpportunityModuleId, VendorModuleId, LocationModuleId].includes(this.moduleId);
            this.sharedChannelService.getChannels(this.moduleId, allList).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
                this.channelNames = res;
            });
        }
    }

    newTemplate() {
        this.isView = false;
        this.selectedEmailTemplate = null;
        this.displayEmailTemplate = true;
    }

    editTemplate(c) {
        if (this.type == 'email') {
            this.selectedEmailTemplate = JSON.parse(JSON.stringify(c));
            this.isView = false;
            this.displayEmailTemplate = true;
        } else if (this.type == 'print') {
            this.printTemp = JSON.parse(JSON.stringify(c));
            this.displayPrintTemplate = true;
        }
    }

    viewTemplate(c) {
        if (this.type == 'email') {
            this.selectedEmailTemplate = JSON.parse(JSON.stringify(c));
            this.isView = true;
            this.displayEmailTemplate = true;
        } else if (this.type == 'print') {
            this.printTemp = JSON.parse(JSON.stringify(c));
            this.displayPrintTemplate = true;
        }
    }

    close() {
        if (this.type == 'email') {
            this.displayEmailTemplate = false;
        } else if (this.type == 'print') {
            this.displayPrintTemplate = false;
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
